import { createSlice } from '@reduxjs/toolkit';
import { isNull } from 'node:util';
import { addExam, autoGenerateQuestion, dashboardExamList, deleteExam, draftExam, exportAllResult, getAllResult, getDeptQuestions, getExam, getExamDetail, getIndividualResult, guestLogin, removeExam, sendMailtoAll, submitExam, submitExam2 } from 'services/store/actions/examAction';

interface ExamState {
  loading: boolean;
  examData: any; // Define the type of userInfo
  error: any; // Define the type of error
  success: boolean;
  loading1: boolean,
  addexamData: any,
  error1: any,
  success1: boolean,
  loading2: boolean,
  deleteexamData: any,
  error2: any,
  success2: boolean,
  //get question data
  loading3: boolean,
  guestInfo: any,
  error3: any,
  success3: boolean,
  //get exam detail,
  loading4: boolean,
  examDetailInfo: any,
  error4: any,
  success4: boolean,
  //submit exam
  loading5: boolean,
  examsubmitInfo: any,
  error5: any,
  success5: boolean
  //individual result
  loading6: boolean,
  sresultInfo: any,
  error6: any,
  success6: boolean,
  //get all result
  loading7: boolean,
  success7: boolean,
  error7: any;
  allResultInfo: any;
  loading8: boolean;
  success8: boolean;
  error8: any;
  rmvExamInfo: any;
  //draft exam
  loading9: boolean;
  error9: any;
  success9: boolean;
  exDraftInfo: any;
  loading10: boolean;
  error10: any;
  success10: boolean;
  exportResInfo: any;
  //exam submit 2
  loading11: boolean;
  error11: any;
  success11: boolean;
  examSubmit2Info: any;
  loading12: boolean;
  error12: any;
  success12: boolean;
  deptQuesInfo: any;
  loading13: boolean;
  error13: any;
  success13: boolean,
  examLinkInfo: any;
  loading14: boolean;
  error14: any;
  success14: boolean;
  dashExamList: any;
  loading15: boolean;
  success15: boolean;
  error15: any;
  autoQuesInfo: any;
}

const initialState: ExamState = {
  loading: false,
  examData: null,
  error: null,
  success: false,
  loading1: false,
  addexamData: null,
  error1: null,
  success1: false,
  loading2: false,
  deleteexamData: null,
  error2: null,
  success2: false,
  //guest login
  loading3: false,
  guestInfo: null,
  error3: null,
  success3: false,
  //examdetail
  loading4: false,
  examDetailInfo: null,
  error4: null,
  success4: false,
  //submit exam
  loading5: false,
  examsubmitInfo: null,
  error5: null,
  success5: false,
  loading6: false,
  sresultInfo: null,
  error6: null,
  success6: false,
  //get all result
  loading7: false,
  error7: null,
  success7: false,
  allResultInfo: null,
  loading8: false,
  success8: false,
  error8: null,
  rmvExamInfo: null,
  loading9: false,
  error9: null,
  success9: false,
  exDraftInfo: null,
  loading10: false,
  error10: null,
  success10: false,
  exportResInfo: null,
  loading11: false,
  error11: null,
  success11: false,
  examSubmit2Info: null,
  loading12: false,
  error12: null,
  success12: false,
  deptQuesInfo: null,
  loading13: false,
  error13: null,
  success13: false,
  examLinkInfo: null,
  loading14: false,
  error14: null,
  success14: false,
  dashExamList: null,
  loading15: false,
  error15: null,
  success15: false,
  autoQuesInfo: null,
}

const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // questionpaper user
    builder
      .addCase(getExam.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = false;
      })
      .addCase(getExam.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.examData = payload;
        state.success = true;
      })
      .addCase(getExam.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
        state.success = false;
      })
      // addquestionpaper user
      .addCase(addExam.pending, (state) => {
        state.loading1 = true
        state.error1 = null
        state.success1 = false;
      })
      .addCase(addExam.fulfilled, (state, { payload }) => {
        state.loading1 = false;
        state.addexamData = payload;
        state.success1 = true;
      })
      .addCase(addExam.rejected, (state, { payload }) => {
        state.loading1 = false;
        state.error1 = payload;
        state.success1 = false;
      })

      // deletequestionpaper user
      .addCase(deleteExam.pending, (state) => {
        state.loading2 = true
        state.error2 = null
        state.success2 = false;
      })
      .addCase(deleteExam.fulfilled, (state, { payload }) => {
        state.loading2 = false;
        state.deleteexamData = payload;
        state.success2 = true;
      })
      .addCase(deleteExam.rejected, (state, { payload }) => {
        state.loading2 = false;
        state.error2 = payload;
        state.success2 = false;
      })
      // guest login
      .addCase(guestLogin.pending, (state) => {
        state.loading3 = true
        state.error3 = null
        state.success3 = false;
      })
      .addCase(guestLogin.fulfilled, (state, { payload }) => {
        state.loading3 = false;
        state.guestInfo = payload;
        state.success3 = true;
      })
      .addCase(guestLogin.rejected, (state, { payload }) => {
        state.loading3 = false;
        state.error3 = payload;
        state.success3 = false;
      })
      //get exam detail
      .addCase(getExamDetail.pending, (state) => {
        state.loading4 = true
        state.error4 = null
        state.success4 = false;
      })
      .addCase(getExamDetail.fulfilled, (state, { payload }) => {
        state.loading4 = false;
        state.examDetailInfo = payload;
        state.success4 = true;
      })
      .addCase(getExamDetail.rejected, (state, { payload }) => {
        state.loading4 = false;
        state.error4 = payload;
        state.success4 = false;
      })
      //submit exam
      .addCase(submitExam.pending, (state) => {
        state.loading5 = true
        state.error5 = null
        state.success5 = false;
      })
      .addCase(submitExam.fulfilled, (state, { payload }) => {
        state.loading5 = false;
        state.examsubmitInfo = payload;
        state.success5 = true;
      })
      .addCase(submitExam.rejected, (state, { payload }) => {
        state.loading5 = false;
        state.error5 = payload;
        state.success5 = false;
      })
      //get individual result
      .addCase(getIndividualResult.pending, (state) => {
        state.loading6 = true
        state.error6 = null
        state.success6 = false;
      })
      .addCase(getIndividualResult.fulfilled, (state, { payload }) => {
        state.loading6 = false;
        state.examsubmitInfo = payload;
        state.success6 = true;
      })
      .addCase(getIndividualResult.rejected, (state, { payload }) => {
        state.loading6 = false;
        state.error6 = payload;
        state.success6 = false;
      })
      .addCase(getAllResult.pending, (state) => {
        state.loading7 = true
        state.error7 = null
        state.success7 = false;
        state.allResultInfo = null;
      })
      .addCase(getAllResult.fulfilled, (state, { payload }) => {
        state.loading7 = false;
        state.allResultInfo = payload;
        state.success7 = true;
      })
      .addCase(getAllResult.rejected, (state, { payload }) => {
        state.loading7 = false;
        state.error7 = payload;
        state.success7 = false;
      })
      .addCase(removeExam.pending, (state) => {
        state.loading8 = true
        state.error8 = null
        state.success8 = false;
        state.rmvExamInfo = null;
      })
      .addCase(removeExam.fulfilled, (state, { payload }) => {
        state.loading8 = false;
        state.rmvExamInfo = payload;
        state.success8 = true;
      })
      .addCase(removeExam.rejected, (state, { payload }) => {
        state.loading8 = false;
        state.error8 = payload;
        state.success8 = false;
      })
      .addCase(draftExam.pending, (state) => {
        state.loading9 = true
        state.error9 = null
        state.success9 = false;
        state.exDraftInfo = null;
      })
      .addCase(draftExam.fulfilled, (state, { payload }) => {
        state.loading9 = false;
        state.exDraftInfo = payload;
        state.success9 = true;
      })
      .addCase(draftExam.rejected, (state, { payload }) => {
        state.loading9 = false;
        state.error9 = payload;
        state.success9 = false;
      })
      .addCase(exportAllResult.pending, (state) => {
        state.loading10 = true
        state.error10 = null
        state.success10 = false;
        state.exportResInfo = null;
      })
      .addCase(exportAllResult.fulfilled, (state, { payload }) => {
        state.loading10 = false;
        state.exportResInfo = payload;
        state.success10 = true;
      })
      .addCase(exportAllResult.rejected, (state, { payload }) => {
        state.loading10 = false;
        state.error10 = payload;
        state.success10 = false;
      })
      .addCase(submitExam2.pending, (state) => {
        state.loading11 = true
        state.error11 = null
        state.success11 = false;
        state.examSubmit2Info = null;
      })
      .addCase(submitExam2.fulfilled, (state, { payload }) => {
        state.loading11 = false;
        state.examSubmit2Info = payload;
        state.success11 = true;
      })
      .addCase(submitExam2.rejected, (state, { payload }) => {
        state.loading11 = false;
        state.error11 = payload;
        state.success11 = false;
      })
      .addCase(getDeptQuestions.pending, (state) => {
        state.loading12 = true
        state.error12 = null
        state.success12 = false;
        state.deptQuesInfo = null;
      })
      .addCase(getDeptQuestions.fulfilled, (state, { payload }) => {
        state.loading12 = false;
        state.deptQuesInfo = payload;
        state.success12 = true;
      })
      .addCase(getDeptQuestions.rejected, (state, { payload }) => {
        state.loading12 = false;
        state.error12 = payload;
        state.success12 = false;
      })
      .addCase(sendMailtoAll.pending, (state) => {
        state.loading13 = true
        state.error13 = null
        state.success13 = false;
        state.examLinkInfo = null;
      })
      .addCase(sendMailtoAll.fulfilled, (state, { payload }) => {
        state.loading13 = false;
        state.examLinkInfo = payload;
        state.success13 = true;
      })
      .addCase(sendMailtoAll.rejected, (state, { payload }) => {
        state.loading13 = false;
        state.error13 = payload;
        state.success13 = false;
      })
      .addCase(dashboardExamList.pending, (state) => {
        state.loading14 = true
        state.error14 = null
        state.success14 = false;
        state.dashExamList = null;
      })
      .addCase(dashboardExamList.fulfilled, (state, { payload }) => {
        state.loading14 = false;
        state.dashExamList = payload;
        state.success14 = true;
      })
      .addCase(dashboardExamList.rejected, (state, { payload }) => {
        state.loading14 = false;
        state.error14 = payload;
        state.success14 = false;
      })
      .addCase(autoGenerateQuestion.pending, (state) => {
        state.loading15 = true
        state.error15 = null
        state.success15 = false;
        state.autoQuesInfo = null;
      })
      .addCase(autoGenerateQuestion.fulfilled, (state, { payload }) => {
        state.loading15 = false;
        state.autoQuesInfo = payload;
        state.success15 = true;
      })
      .addCase(autoGenerateQuestion.rejected, (state, { payload }) => {
        state.loading15 = false;
        state.error15 = payload;
        state.success15 = false;
      });
  },
})
export default examSlice.reducer